// extracted by mini-css-extract-plugin
module.exports = {"color-white":"theme_color-white__1EtHe","color-black":"theme_color-black__1BYqF","color-default-gray":"theme_color-default-gray__1SIcg","default":"theme_default__2LX0a"};